module.exports = __webpack_public_path__ + "img/5559756.svg";